<div [ngClass]="{
    'hidden': router.url.includes('/agata')||
            router.url.includes('/inicio')||
            router.url === '/'
    }">
    <app-navbar [logoGov]="logoGov"></app-navbar>
</div>


<router-outlet></router-outlet>

<app-alerts></app-alerts>

<div [ngClass]="{
    'hidden': router.url.includes('/agata')||
            router.url.includes('/inicio')||
            router.url === '/'
    }">
    <app-footer [footerImgs]="footerImgs"></app-footer>
</div>
